import React from "react";
import { Link } from "react-router-dom";
import AdminPageShell from "./AdminPageShell";

import useFetch from "../../useFetch";

const money = (amount, currency = "USD") => `${currency} ${Number(amount || 0).toFixed(2)}`;
const formatDate = (date) => date ? new Date(date).toLocaleDateString() : "-";

const AdminPayments = () => {
  const { response, isLoading, error } = useFetch(process.env.REACT_APP_BASE_API_URL + "/admin/payments");
  const payments = response?.payments?.data ?? [];
  const stats = response?.payments?.stats ?? {};

  return (
    <AdminPageShell
      active="payments"
      title="Payments"
      text="Review job posting credit purchases and payment activity."
    >
      <div className="row">
        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
          <div className="ui-item">
            <div className="left"><i className="icon la la-dollar-sign"></i></div>
            <div className="right">
              <h4>{money(stats.paid_total ?? 0)}</h4>
              <p>Paid Total</p>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
          <div className="ui-item ui-green">
            <div className="left"><i className="icon la la-check-circle"></i></div>
            <div className="right">
              <h4>{stats.paid_count ?? 0}</h4>
              <p>Paid Invoices</p>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
          <div className="ui-item ui-red">
            <div className="left"><i className="icon la la-times-circle"></i></div>
            <div className="right">
              <h4>{stats.failed_count ?? 0}</h4>
              <p>Failed Payments</p>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
          <div className="ui-item ui-yellow">
            <div className="left"><i className="icon la la-file-invoice"></i></div>
            <div className="right">
              <h4>{stats.invoice_count ?? 0}</h4>
              <p>Total Invoices</p>
            </div>
          </div>
        </div>
      </div>

      {error && <div className="alert alert-danger"><strong>{error}</strong></div>}
      {isLoading && <h5 className="text-center my-3">Loading Data</h5>}

      <div className="ls-widget">
        <div className="widget-title">
          <h4>Payment Records</h4>
          <Link to="/pricing" className="theme-btn btn-style-three">View Pricing</Link>
        </div>
        <div className="widget-content">
          <div className="admin-table-list">
            {payments.map((payment) => (
              <div className="admin-table-row" key={payment.id}>
                <div>
                  <strong>{payment.employer_name ?? "Employer"} - {payment.invoice_number}</strong>
                  <span>{payment.item_name} - {money(payment.total, payment.currency)} - {formatDate(payment.paid_at || payment.created_at)}</span>
                  {payment.stripe_checkout_session_id && <span>Stripe session: {payment.stripe_checkout_session_id}</span>}
                </div>
                <span className={payment.status === "failed" ? "danger" : ""}>{payment.status}</span>
              </div>
            ))}
            {!isLoading && payments.length === 0 && <div className="admin-empty-state">No payments found.</div>}
          </div>
        </div>
      </div>
    </AdminPageShell>
  );
};

export default AdminPayments;
